import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { api } from "~/api/client";
import type { TokenMeta } from "~/api/types";

export function useTokenList(chainId: string | undefined) {
  const [search, setSearch] = useState("");

  const { data, isLoading, error } = useQuery({
    queryKey: ["tokens", chainId],
    queryFn: () => api.getTokens(chainId!),
    enabled: !!chainId,
    staleTime: 60 * 60 * 1000, // 1h
  });

  const allTokens: TokenMeta[] = data?.tokens ?? [];

  const tokens: TokenMeta[] = useMemo(() => {
    if (!search) return allTokens;
    const q = search.toLowerCase();
    return allTokens.filter(
      (t) =>
        t.symbol?.toLowerCase().includes(q) ||
        t.name?.toLowerCase().includes(q) ||
        t.address?.toLowerCase() === q,
    );
  }, [allTokens, search]);

  return { tokens, allTokens, isLoading, error, search, setSearch };
}
